import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lumen_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (err) => {
  // Accept the full error object OR a detail value
  if (err && err.isAxiosError !== undefined) {
    if (err.response) {
      const detail = err.response.data?.detail;
      if (typeof detail === "string") return detail;
      if (Array.isArray(detail))
        return detail
          .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
          .join(" ");
      if (detail && typeof detail.msg === "string") return detail.msg;
      return `Server error (${err.response.status})`;
    }
    if (err.request) return "Network error — cannot reach server. Check your connection or backend URL.";
    return err.message || "Request failed";
  }
  // Legacy: passed a detail value directly
  const detail = err;
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const PIPELINE_STAGES = [
  { key: "inquiry", label: "Inquiry", color: "#64748B" },
  { key: "discovery_scheduled", label: "Discovery", color: "#3B82F6" },
  { key: "pre_production", label: "Pre-Production", color: "#8B5CF6" },
  { key: "filming", label: "Filming", color: "#E53E3E" },
  { key: "editing", label: "Editing", color: "#F59E0B" },
  { key: "review", label: "Review", color: "#EAB308" },
  { key: "delivered", label: "Delivered", color: "#10B981" },
];

export const stageLabel = (s) =>
  PIPELINE_STAGES.find((x) => x.key === s)?.label || s;
export const stageColor = (s) =>
  PIPELINE_STAGES.find((x) => x.key === s)?.color || "#52525B";
